import React from 'react';
import PropTypes from 'prop-types';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import AccountsShow from './AccountsShow';
import fetchResourceById from 'components/hoc/fetchResourceById';
import { fetchAccount } from 'store/actions/accounts/fetchAccounts';

class AccountsShowContainer extends React.Component {
    render() {
        const {
            data,
            history,
            id,
            resource,
            resourceFetchFailed,
            resourceFetchLoading,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        if (!data) {
            return null;
        }

        return <AccountsShow
            id={ id }
            history={ history }
            record={ data }
            resource={ resource }
        />;
    }
}

AccountsShowContainer.propTypes = {
    data: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    resource: PropTypes.string.isRequired,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
};

const fetchValues = {
    resource: 'accounts',
    action: fetchAccount,
};

export default fetchResourceById(fetchValues)(AccountsShowContainer);



// WEBPACK FOOTER //
// ./src/pages/accounts/show/AccountsShowContainer.js